import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import RatingsActions from '../../Data/Redux/RatingsRedux'
import Tool from '../../Components/ReportsComponents/Tool'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import ReportTemplate from './ReportTemplate'

const COLORS = ['#152940', '#4B3F72', '#904C77', '#119DA4', '#53A2FF']

class AvgDailyRatings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [],
    }
  }

  componentWillMount() {
    if (!this.props.fromCenter) {
      this.props.getRatings()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newState = { ...this.state }
    const { ratings, centers, centersInfo } = nextProps
    if (ratings && centers) {
      Object.keys(ratings).map((key) => {
        const day = { day: key, formatDay: moment(key).format('MMM DD') }
        ratings[key].map((rating) => {
          if (centers.length > 0) {
            const { abbreviation } = centers.find(center => center.id === rating.center_id)
            day[abbreviation] = parseFloat(rating.avg_rating)
          }
        })
        newState.data.push(day)
      })
      this.setState(newState)
    }
    if (centersInfo && centers) {
      Object.keys(centersInfo).map((key) => {
        const day = { day: key, formatDay: moment(key).format('MMM DD') }
        centersInfo[key].map((info) => {
          if (centers.length > 0) {
            const { abbreviation } = centers.find(center => center.id === info.center_id)
            day[abbreviation] = parseFloat(info.avg_rating)
          }
        })
        newState.data.push(day)
      })
      this.setState(newState)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  getLines = () => {
    const lines = this.props.centers.map((value, index) => {
      return (
        <Line key={index} connectNulls type="monotone" dataKey={value.abbreviation} stroke={this.pickColor(value.abbreviation) ? COLORS[index % COLORS.length] : 'gray'} activeDot={{ r: 8 }} />
      )
    })
    return lines
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  filter = ({ currentTarget: { id: abbreviation } }) => {
    const newState = { ...this.state }
    const { ratings, centers } = this.props
    const { id } = centers.find(center => center.abbreviation === abbreviation)
    for (let i = 0; i < newState.data.length; i++) {
      if (newState.data[i][abbreviation] && (newState.data[i][abbreviation] !== 0 && newState.data[i][abbreviation] !== null)) {
        newState.data[i][abbreviation] = null
      } else if (newState.data[i][abbreviation] === 0 || newState.data[i][abbreviation] === null) {
        const { day } = newState.data[i]
        const rating = ratings[day]
        const centerRating = rating.find(rt => rt.center_id === id)
        newState.data[i][abbreviation] = parseFloat(centerRating.avg_rating)
      }
    }
    this.setState(newState)
  }

  pickColor = (name) => {
    let count = 0
    for (let i = 0; i < this.state.data.length; i++) {
      if (this.state.data[i][name] && this.state.data[i][name] !== 0) {
        count++
      }
    }
    return count > 0
  }

  render() {
    const { width, data } = this.state
    const { fromCenter } = this.props
    return (
      <ReportTemplate
        title="Promedio de ratings: Diario"
        withOutExcel
        date={data[0] &&
          { initial: data[0].day, end: data[data.length - 1].day }}
        loading={!data[0]}
      >
        {data[0] &&
          <LineChart
            width={width < 763 ? 400 : 648}
            height={width < 763 ? 300 : 400}
            data={data}
            margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey="formatDay" />
            <YAxis type="number" domain={['0', '5']} />
            <Tooltip content={<Tool withoutTotal withoutCurrency large />} />
            <Legend content={<CustomizedLegend onClick={!fromCenter && this.filter} />} />
            {this.getLines()}
          </LineChart>
        }
      </ReportTemplate>
    )
  }
}


const mapStateToProps = ({ ratings, centerOptions, centersInfo }) => ({
  ratings: ratings.get.results.avg_daily_ratings,
  centers: centerOptions.get.results,
  centersInfo: centersInfo.ratings.results.avg_daily_ratings,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getRatings: () => dispatch(RatingsActions.getRequest({}, true)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AvgDailyRatings))



// WEBPACK FOOTER //
// ./src/Containers/Reports/AvgDailyRatings.jsx